import Vue from 'vue'

Vue.filter('formatMoney', (number) => {
  let signal = ''
  if (number < 0) {
    signal = '-'
    number = number * -1
  }

  if (number < 100000) {
    return `${signal} R$ ${(number / 100).toFixed(2).replace('.', ',')}`
  }
  if (number >= 100000 && number < 99999999) {
    return `${signal}R$ ${(number / 100000).toFixed(2).replace('.', ',')} K`
  }
  if (number >= 99999999) {
    return `${signal}R$ ${(number / 100000).toFixed(2).replace('.', ',')} M`
  }
})

Vue.filter('formatFullMoney', (number) => {
  return `R$ ${(number / 100).toFixed(2).replace('.', ',')}`
})

Vue.filter('formatFreight', (value) => {
  if (!value) return ''
  return value.toFixed(2)
})

Vue.filter('formatDate', (date) => {
  if (!date) return ''
  return date
    .slice(0, 10)
    .split('-')
    .reverse()
    .join('/')
})

Vue.filter('formatPhone', (phone) => {
  if (!phone) return ''
  return phone.replace(/(\w{3})(\d{2})(\d{5})(\d{4})/g, '$1($2) $3-$4')
})

Vue.filter('formatDate2', (date) => {
  if (!date) return ''
  return new Date(date).toLocaleDateString('pt-BR', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })
})

Vue.filter('formatFullDate', (date) => {
  if (!date) return ''
  const time = date
    .slice(11, 19)
    .split('-')
    .join(':')
  return (
    date
      .slice(0, 10)
      .split('-')
      .reverse()
      .join('/') +
    ' ' +
    time
  )
})

Vue.filter('uppercase', (text) => {
  return text.toUpperCase()
})

Vue.filter('capitalize', (s) => {
  if (typeof s !== 'string') return ''
  return (
    s
      .toLowerCase()
      .charAt(0)
      .toUpperCase() + s.slice(1)
  )
})

Vue.filter('formatTpDoc', (tpDoc) => {
  if (tpDoc === 1) return 'CNPJ'
  else return 'CPF'
})

Vue.filter('pretty', (value) => {
  return JSON.stringify(JSON.parse(value), null, 2)
})

Vue.filter('formatDoc', (doc, item) => {
  if (doc === undefined) return ''
  if (item.doc_tp_seller === 1) {
    return doc.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5')
  } else {
    return doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
  }
})

Vue.filter('formatCPF', (cpf) => {
  if (cpf === undefined) return ''
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
})

Vue.filter('formatDocument', (data) => {
  if (!data) return ''
  if (data.length === 11) {
    return data.toString().replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
  } else {
    return data.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5')
  }
})

Vue.filter('formatPriceTag', (tag) => {
  if (tag.search('saldao')) {
    return 'Saldão'
  } else if (tag.search('colaboradores')) {
    return 'Preço para Colaboradores'
  } else {
    return ''
  }
})
